import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import HeroHomepageWebThree from '../components/HeroHomepageWebThree'
import FeaturedWorkWeb3 from '../components/FeaturedWorkWeb3'
import TestimonialsWebThree from '../components/TestimonialsWebThree'
import LineWebThree from '../components/LineWebThree'

const HomepageWebThree = () => {
  return (
    <div className='bg-backgroundweb3'>
      <Header />
      <HeroHomepageWebThree/>
      <LineWebThree/>
      <FeaturedWorkWeb3/>
      <LineWebThree/>

      <TestimonialsWebThree/>
      <Footer />
    </div>
  )
}

export default HomepageWebThree 